import React from "react";
import EducationForm from "./educationForm";
import EmploymentForm from "./employmentForm";
import CharacterForm from "./characterForm";
import ReferencesSingleSelect from "./referencesSingleSelect";

class ReferencesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      niNumber: props.niNumber,
      dateOfBirth: props.dateOfBirth,
      token: props.token,
      formType:
        props.initialState && props.initialState.referenceType
          ? props.initialState.referenceType
          : undefined
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.saveReference = this.saveReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  saveReference(data) {
    const { responsibleTeam } = this.props;
    const mapToMainBranch = {
      HKAS: "HKAS",
      HBII: "HBII",
      HBIC: "HBII",
      HBIE: "HBII",
      HBSS: "HBII",
      HWBR: "HWBR",
      HKCA: "HKCA",
      HKCT: "HKCA",
      HKCH: "HKCH",
      HKDA: "HKDA",
      HXTD: "HXTD",
      DONC: "DONC",
      DONT: "DONC",
      HDOV: "HDOV",
      HDOS: "HDOV",
      HUGR: "HUGR",
      HUGS: "HUGR",
      SUSX: "SUSX",
      HHUN: "HHUN",
      HNHC: "HHUN",
      HNHN: "HHUN",
      LIVG: "LIVG",
      LALD: "LIVG",
      LISA: "LIVG",
      LIVM: "LIVG",
      LIVR: "LIVG",
      LIVX: "LIVG",
      LPET: "LIVG",
      HNNN: "HNNN",
      HXND: "HNNN",
      NONF: "NONF",
      HXSD: "NONF",
      HNPT: "HNPT",
      HXPD: "HNPT",
      HKRA: "HKRA",
      HKRG: "HKRA",
      JSHM: "JSHM",
      HSTO: "HSTO",
      HSTS: "HSTO",
      HTNE: "HTNE",
      HTNS: "HTNE",
      HBUP: "HBUP",
      HBUC: "HBUP",
      HBUE: "HBUP",
      HBUI: "HBUP",
      HBUO: "HBUP",
      HBUS: "HBUP",
      HWAT: "HWAT",
      HWAS: "HWAT",
      HLLS: "DONC"
    };
    const branchData =
      window._umbraco_branches && // eslint-disable-line
      // eslint-disable-next-line
      window._umbraco_branches.find(
        // eslint-disable-line
        b => b.code === mapToMainBranch[responsibleTeam]
      ); // eslint-disable-line
    const branchEmail = branchData && branchData.email;
    const enrichedData = {
      candidateName: this.state.name,
      branchEmail,
      ...data
    };
    this.props.saveReference(enrichedData);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={true}
          readOnly={true}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.TextInput({
          id: "name",
          label: "Candidate's Name",
          value: this.state.name
        })}
        {(this.state.formType === "employment" ||
          this.state.formType === "education") &&
          this.TextInput({
            id: "dob",
            label: "Candidate's Date of Birth",
            value: this.state.dateOfBirth
          })}
        {this.state.formType === "employment" &&
          this.TextInput({
            id: "niNumber",
            label: "Candidate's NI Number",
            value: this.state.niNumber
          })}
        <ReferencesSingleSelect
          description="Is this an Employment, Education or Character reference?"
          value={this.state.formType}
          name="formType"
          onSelect={this.handleInputChange}
          options={["employment", "education", "character"]}
        />

        {this.state.formType === "employment" && (
          <EmploymentForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
            token={this.props.token}
          />
        )}
        {this.state.formType === "education" && (
          <EducationForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
            token={this.props.token}
          />
        )}
        {this.state.formType === "character" && (
          <CharacterForm
            saveReference={this.saveReference}
            initialState={this.props.initialState}
            token={this.props.token}
          />
        )}
      </div>
    );
  }
}

export default ReferencesForm;
